import { useCallback } from 'react';
import { googleAnalyticsClient } from '../clients';

/**
 * This only supports GA currently but it is generally named so that we can
 * Add extra clients in the future.
 */
const useSetGlobalAnalyticsProperties = () =>
  useCallback((properties = {}) => {
    googleAnalyticsClient.setGlobalGAProps(properties);
  }, []);

export default useSetGlobalAnalyticsProperties;
